import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Cosmic Flower — spiraling mandala-like bloom.
 * julia3D + heart3D for petal symmetry, cross3D + spherical3D
 * for the central structure, and ex3D for fractal detailing.
 */
export const example43 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Cosmic Flower',
    description:
      'spiraling mandala-like bloom. julia3D + heart3D for petal symmetry, cross3D + spherical3D for the central structure, and ex3D for fractal detailing.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.3,
    skipIters: 22,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.4,
    contrast: 5.2,
    gamma: 3.6,
    depthColorPower: 0.0,
    lightDirection: [-0.3, 0.5, -0.8],
    lightPower: 0.1,
    highlightPower: 1.3,
    densityEstimationQuality: 0.65,
    estimatorCurve: 0.38,
    paletteMode: 0,
    palettePhase: 0.55,
    paletteSpeed: 0.5,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 4.2,
      phi: 1.5,
      radius: 2.0,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_flower_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.8,
        b: 0,
        c: 0.1,
        d: 0,
        e: 0,
        f: 0.8,
        g: -0.1,
        h: 0,
        i: -0.1,
        j: 0.1,
        k: 0.8,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.15, y: 0.4 },
      colorSpeed: 0.45,
      variations: {
        [vid('3d_flower_a_v0')]: { type: 'julia3D', weight: 0.8 },
        [vid('3d_flower_a_v1')]: { type: 'heart3D', weight: 0.4 },
      },
    },
    [tid('3d_flower_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.6,
        b: 0.15,
        c: 0,
        d: 0,
        e: -0.15,
        f: 0.6,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.6,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.25, y: 0.1 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_flower_b_v0')]: { type: 'cross3D', weight: 0.5 },
        [vid('3d_flower_b_v1')]: { type: 'spherical3D', weight: 0.5 },
      },
    },
    [tid('3d_flower_c')]: {
      probability: 0.3,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0.1,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: -0.15 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_flower_c_v0')]: { type: 'ex3D', weight: 0.6 },
        [vid('3d_flower_c_v1')]: { type: 'julia3D', weight: 0.4 },
      },
    },
  },
})
